import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth, useIsDemoUser, useAppDispatch } from '@/hooks/redux';
import { isGuestUser } from '@/utils';
import { setLoginModalOpen } from '@/store/slices/uiSlice';

export function ProtectedRoute() {
  const { isLoading } = useAuth();
  const isGuest = isGuestUser();
  const isDemoUser = useIsDemoUser();
  const dispatch = useAppDispatch();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (isGuest || isDemoUser) {
    // Open global login modal and redirect to home so user sees modal popup
    dispatch(setLoginModalOpen(true));
    return <Navigate to="/home" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
